const mistakes = [
  {
    title: 'Ошибка 1. Создать список резервистов и ничего не делать дальше',
    desc: 'Сам факт включения сотрудника в резерв ничего не развивает.',
  },
  {
    title: 'Ошибка 2. Выбирать только лучших исполнителей',
    desc: 'Высокий профессиональный результат не гарантирует управленческого потенциала.',
  },
  {
    title: 'Ошибка 3. Отправлять всех на одинаковое обучение',
    desc: 'У разных сотрудников разные дефициты компетенций.',
  },
  {
    title: 'Ошибка 4. Не давать практики',
    desc: 'Без применения новые навыки быстро теряются.',
  },
  {
    title: 'Ошибка 5. Не подключать руководителя',
    desc: 'Развитие невозможно отделить от реальной работы.',
  },
  {
    title: 'Ошибка 6. Не определять будущую должность',
    desc: 'Невозможно понять, к чему готовить человека, если неизвестно, какую роль он должен выполнять.',
  },
  {
    title: 'Ошибка 7. Не проверять результат',
    desc: 'Если нет повторной оценки, компания не понимает, стал ли сотрудник действительно более готов к новой роли.',
  },
];

export default function WhatNotWorks() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что не работает в кадровом резерве
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-12">
          Типичные ошибки компаний
        </p>

        <div className="space-y-4">
          {mistakes.map((m, i) => (
            <div key={i} className="flex items-start gap-4 bg-gray-50 rounded-xl border border-gray-200 p-5 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-close-line text-red-500 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1">{m.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}